var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDispositivos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-4818 -2815)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(45 605)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4818 2815)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4855 -3412)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H7.078V8.438H0Z",
    fill: "#6c2cb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.945H7.078v2.813H0Z",
    transform: "translate(0 -4.102)",
    fill: "#6c2cb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.988,11.953h9.891V23.2H19.988Z",
    transform: "translate(-5.879 -3.516)",
    fill: "#6c2cb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.988,29.883h9.891v2.906H19.988Z",
    transform: "translate(-5.879 -8.789)",
    fill: "#6c2cb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.484,3.984v11.25H0v5.625H12.7V8.2H24V3.984Z",
    transform: "translate(0 -1.172)",
    fill: "#6c2cb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.434,31.383H10.027v1.406h5.625V29.883H11.434Z",
    transform: "translate(-2.949 -8.789)",
    fill: "#6c2cb8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispositivos);
export default __webpack_public_path__ + "static/media/dispositivos.1a9d3dbdf6e8a4916de8c5dc3f799328.svg";
export { ForwardRef as ReactComponent };